// Отображение валюты клуба в бекофисе. Сумма всегда в BYN — настройка меняет
// только ПОДПИСЬ рядом с числом (знак / BYN / бел.руб). Источник истины —
// @billiard/shared; выбранное клубом значение приходит через ClubContext.

import { CURRENCY_SIGN_SVG, currencyText, type CurrencyDisplay } from '@billiard/shared'
import { useClubContext } from '@/context/ClubContext'
import { money } from '@/lib/format'

/** Текущее отображение валюты выбранного клуба (по умолчанию ISO-код BYN). */
export function useCurrency(): CurrencyDisplay {
  return useClubContext().currencyDisplay
}

/**
 * Подпись валюты для JSX: знак рисуется inline-SVG, остальное — текст ('BYN' /
 * 'бел.руб'). Без пропсов читает отображение из ClubContext; можно передать
 * `display` явно (например, в формах онбординга, где клуб ещё не в контексте).
 */
export function Cur({ display }: { display?: CurrencyDisplay }): React.JSX.Element {
  const ctxDisplay = useClubContext().currencyDisplay
  const d = display ?? ctxDisplay
  if (d === 'symbol') {
    return <span className="cur-sign" dangerouslySetInnerHTML={{ __html: CURRENCY_SIGN_SVG }} />
  }
  return <>{currencyText(d)}</>
}

/**
 * Сумма с подписью валюты выбранного клуба: «12 500 <знак/BYN/бел.руб>».
 * Удобная замена для JSX-мест, где раньше было `{money(x)}` (а подпись BYN
 * добавлял сам money). Подпись уважает клубную настройку отображения.
 */
export function Money({ value }: { value: number }): React.JSX.Element {
  return (
    <>
      {money(value)} <Cur />
    </>
  )
}
